<template>
  <!-- MODIFICARR ESTEBANNN NO SE LE OLVIDEEE XD -->
  <div class="open-ended-container">
    <div class="container">
      <!-- Progress Header -->
      <div class="progress-section">
        <div class="progress-info">
          <span class="progress-label">Preguntas Abiertas (Paso Final)</span>
          <span class="progress-label">Progreso: 100%</span>
        </div>
        <b-progress :value="100" type="is-primary" size="is-small" />
      </div>

      <!-- Main Card -->
      <div class="card">
        <header class="card-header">
          <div class="card-header-title is-block">
            <h1
              class="title is-spaced is-size-3-desktop is-size-4-mobile has-text-weight-bold mb-2"
            >
              {{ group.title || "" }}
            </h1>
            <p
              class="subtitle is-size-6-desktop is-size-6-mobile has-text-grey"
            >
              {{ group.text || "" }}
            </p>
          </div>
        </header>

        <div class="card-content">
          <div class="questions-wrapper">
            <div
              v-for="(question, index) in questions"
              :key="question.id"
              class="question-item"
            >
              <label :for="question.id" class="label question-label">
                {{ index + 1 }}. {{ question.text }}
              </label>
              <b-field>
                <b-input
                  :id="question.id"
                  v-model="currentAnswers[question.id]"
                  type="textarea"
                  :placeholder="
                    question.placeholder || 'Escribe tu respuesta aquí...'
                  "
                  rows="2"
                  @input="handleAnswerChange(question.id, $event)"
                />
              </b-field>
              <p class="character-count">
                {{ currentAnswers[question.id].length }} caracteres
              </p>
            </div>

            <!-- Warning Message -->
            <!-- <b-message
              v-if="!allAnswered && someAnswered"
              class="mt-5"
              type="is-warning"
              has-icon
              icon="alert-circle-outline"
              icon-size="is-small"
            >
              Por favor, responde todas las preguntas antes de finalizar
            </b-message> -->
          </div>
        </div>

        <footer class="card-footer">
          <div class="card-footer-item">
            <b-button
              type="is-primary"
              size="is-medium"
              expanded
              :disabled="isLoading"
              @click="handleBack"
            >
              Volver
            </b-button>
            <b-button
              v-if="group.sizeGroups === groupNumber + 1"
              type="is-primary"
              size="is-medium"
              expanded
              :disabled="isLoading"
              :loading="isLoading"
              @click="handleSubmit"
            >
              {{ isLoading ? "Enviando..." : "Finalizar Encuesta" }}
            </b-button>
            <b-button
              v-else
              type="is-primary"
              size="is-medium"
              expanded
              :disabled="isLoading"
              :loading="isLoading"
              @click="handleSubmit"
            >
              {{ isLoading ? "Guardando..." : "Siguiente" }}
            </b-button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenEndedQuestions",
  props: {
    survey: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    groupNumber: {
      type: Number,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    let answers = {};

    if (this.survey.openQuestions) {
      answers = this.survey.openQuestions;
    }

    const init = this.questions.reduce((acc, q) => {
      acc[q.id] = "";
      return acc;
    }, {});
    answers[this.groupNumber] = init;

    return {
      answers,
      currentAnswers: answers[this.groupNumber],
      isLoading: false,
    };
  },
  methods: {
    handleAnswerChange(questionId, value) {
      this.$set(this.currentAnswers, questionId, value);
      this.$set(this.answers[this.groupNumber], questionId, value);
    },
    handleSubmit() {
      this.isLoading = true;
      this.$emit("complete", {
        type: "open-ended",
        groupNumber: this.groupNumber,
        answers: this.answers,
      });
      this.isLoading = false;
    },
    handleBack() {
      this.$emit("back", {
        type: "open-ended",
        groupNumber: this.groupNumber,
      });
    },
  },
  watch: {
    groupNumber(newVal) {
      if (!this.answers[newVal]) {
        const initAnswers = this.questions.reduce((acc, q) => {
          acc[q.id] = "";
          return acc;
        }, {});
        this.$set(this.answers, newVal, initAnswers);
      }

      this.currentAnswers = this.answers[newVal] || {};
    },
  },
};
</script>

<style scoped>
.open-ended-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 2rem 1rem;
}

.container {
  max-width: 960px;
  margin: 0 auto;
}

/* Progress Section */
.progress-section {
  margin-bottom: 1.5rem;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.progress-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #7a7a7a;
}

/* Card */
.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 1.5rem;
}

.card-content {
  padding: 1.5rem;
}

/* Questions */
.questions-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.question-item {
  margin-bottom: 0;
}

.question-label {
  font-size: 1rem;
  font-weight: 500;
  color: #363636;
  margin-bottom: 0.5rem;
}

/* Textarea styling */
.question-item >>> textarea {
  min-height: 60px;
  max-height: 200px;
  resize: vertical;
  font-family: inherit;
}

/* Character count */
.character-count {
  font-size: 0.75rem;
  color: #7a7a7a;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

/* Card Footer */
.card-footer-item {
  display: flex;
  padding: 1.5rem;
  justify-content: space-between;
  gap: 0.5rem;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .open-ended-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .card-footer-item {
    padding: 1rem;
  }

  .title.is-4 {
    font-size: 1.25rem;
  }

  .questions-wrapper {
    gap: 1rem;
  }
}

@media screen and (min-width: 769px) and (max-width: 1023px) {
  .container {
    max-width: 720px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/OpenEndedQuestions.vue